import * as React from 'react';
import { Image, Logging } from '@vcd-ecm-ui/Common';
import '../sidebyside-viewer.scss';
import SideBySideViewerContentRightProps from './SizeBySideViewerContentRightProps.interface';
import DocumentViewer from '../DocumentViewer/DocumentViewer';

const SideBySideViewerContentRight = ({
  certificate,
  editable,
}: SideBySideViewerContentRightProps): JSX.Element => {
  // No valid certificate
  if (!certificate) {
    return (<></>);
  }

  return (
    <div className="sbsContentRight">
      {
        !certificate.certificateImage
          ? (
            <div className="sbsContentRightDocumentUnavailable">
              Certificate Document not Available
            </div>
          )
          : (
            <>
              <div className="sbsContentRightDocument">
                <DocumentViewer idPrefix="cert" canRotate={false} imageDocument={certificate.certificateImage} />
              </div>
            </>
          )
      }
    </div>
  );
};

export default SideBySideViewerContentRight;
